import { styled } from '../../Styles/stitches.config'
import { StyledSVG } from '../SVG/styles'

export const StyledIconButton = styled('button', {
    borderRadius: '$1',
    display: 'grid',
    cursor: 'pointer',
    gap: '$1',
    padding: '$3',
    placeItems: 'center',
    size: 80,

    variants: {
        selected: {
            true: {
                bgc: '$white',
                border: '2px solid $primary600',

                [`& ${StyledSVG}`]: {
                    color: '$primary600',
                },
            },
            false: {
                bgc: '$neutral200',
                border: '2px solid $neutral200',

                [`& ${StyledSVG}`]: {
                    color: '$black',
                },
            },
        },
    },
})
